import { Navigate, useSearchParams } from 'react-router';

import { TokenTypeCode } from '@/services/types';
import { ServiceErrorCode } from '@/services/utils/service-error';
import { decodeJwt } from '@/utils/jwt-utils';

import { VerifyInvite } from './verify-invite-section';

export default function VerifyInvitePage() {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';

  if (!token || !email) {
    return <Navigate to="/login" replace />;
  }

  const decoded = decodeJwt<{
    inviteToken: string;
    organizationName: string;
    organizationId: number;
    passwordResetToken: string | undefined;
    googleToken: string | undefined;
  }>(token);
  if (!decoded?.inviteToken) {
    const params = new URLSearchParams({
      token,
      email,
      type: TokenTypeCode.ORG_INV,
      errorCode: ServiceErrorCode.InvalidToken,
    }).toString();
    return <Navigate to={`/verify/error?${params}`} replace />;
  }

  const { passwordResetToken, organizationName, organizationId, googleToken } =
    decoded;

  return (
    <VerifyInvite
      email={email}
      organizationName={organizationName}
      organizationId={organizationId}
      passwordResetToken={passwordResetToken}
      googleToken={googleToken ?? ''}
    />
  );
}
